<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
		<path
			id="Path_30437"
			data-name="Path 30437"
			d="M30,0A30,30,0,1,1,0,30,30,30,0,0,1,30,0"
			transform="translate(2 2)"
			fill="#7e7fe7"
			stroke="#5b5be6"
			stroke-width="4"
		/>
		<path
			id="Path_30438"
			data-name="Path 30438"
			d="M44.558,28.13a3.461,3.461,0,0,1,1.339,4.71,3.536,3.536,0,0,1-1.339,1.339L27.32,43.751a3.457,3.457,0,0,1-5.14-3.025V21.575a3.453,3.453,0,0,1,5.14-3.025Z"
			transform="translate(0.588 0.85)"
			fill="#fff"
		/>
	</svg>
</template>

<script>
export default {
	name: 'PlaySvg',
};
</script>

<style scoped lang="scss"></style>
